import { render } from "./MySelect2.vue?vue&type=template&id=0249152c&scoped=true"
import script from "./MySelect2.vue?vue&type=script&lang=js"
export * from "./MySelect2.vue?vue&type=script&lang=js"

import "./MySelect2.vue?vue&type=style&index=0&id=0249152c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0249152c"

export default script